'use client';

import { Button } from '@/components/ui/button';
import { scrollToElement } from '@/util/helpers';
import Image from 'next/image';

export default function FindPlans() {
  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 max-w-4xl mx-auto">
          <div className="md:w-1/2">
            <Image
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-P4v9r3C1gFJu2blUNAUSnofOQXLEkW.png"
              alt="Professional mechanic smiling while working on a car engine"
              width={400}
              height={400}
              className="rounded-lg object-cover"
            />
          </div>
          <div className="md:w-1/2 text-center md:text-left">
            <h2 className="text-3xl font-bold mb-4">Ready to find the perfect extended car warranty?</h2>
            <p className="text-gray-600 mb-6">
              Compare vehicle service contracts and car protection plans tailored to your needs.
            </p>
            <Button
              className="bg-[#00B67A] hover:bg-[#00A067]"
              size="lg"
              onClick={() => {
                scrollToElement('vehicleSearchForm');
              }}
            >
              Get My Plan
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
